<div class="doctor-header-container">

    <mat-card *ngIf="showCard">
        <mat-card-header>
            <!--<div mat-card-avatar class="avatar icon" *ngIf="showIconAvatar()">
                <mat-icon fontSet="phr-iconset" [ngClass]="getProfileTypeIconClassName()"></mat-icon>
            </div>
            <div mat-card-avatar class="avatar" *ngIf="showImageAvatar()" [ngStyle]="{backgroundImage:'url(' + publicProfile.ubicacionFoto + ')'}"></div>
            <span mat-card-avatar class="avatar" *ngIf="showInitialsAvatar()" [ngStyle]="{'background-color': initials.color}">
                {{initials.initials}}
            </span>-->

            <div mat-card-avatar class="avatar" *ngIf="avatarModel">                
                <app-public-profile-avatar [model]="avatarModel"></app-public-profile-avatar>
            </div>

            <mat-card-title>
                {{publicProfile.nombrePersona}}
                <img src="assets/images/cliniweb/medical-orders/check-validacion-perfil-big.svg" *ngIf="isVerifiedDoctor.isVerified">
            </mat-card-title>
            <mat-card-subtitle>{{specialties}}</mat-card-subtitle>
            <mat-card-subtitle class="subEspecialidad" *ngIf="subspecialties">{{subspecialties}}</mat-card-subtitle>
            <mat-card-subtitle class="licencia" *ngIf="isVerifiedDoctor.license && isVerifiedDoctor.isVerified">
                <img src="https://s3.amazonaws.com/docs.public/images/iconos/Frame.png">
                {{isVerifiedDoctor.license}} - {{'shared.professionalLicense.title' | translate:locale.language}}
            </mat-card-subtitle>

            <mat-card-subtitle class="social-media-container">
                <div class="social-media-item" *ngIf="instagramSocialMedia">
                    <a class="social-media-link" (click)="onSocialMediaClick(instagramSocialMedia)">
                        <mat-icon fontSet="phr-iconset" [ngClass]="getSocialMediaIcon(instagramSocialMedia)"></mat-icon>
                    </a>
                </div>
                <div class="social-media-item">
                    <a class="social-media-link" (click)="sendMessage()">
                        <mat-icon fontSet="phr-iconset" class="phr-iconset-mail"></mat-icon>
                    </a>
                </div>
                <div class="social-media-item" *ngIf="publicProfile.sitioWeb">
                    <a class="social-media-link" (click)="onWebsiteClick(publicProfile.sitioWeb)">
                        <mat-icon fontSet="phr-iconset" class="phr-iconset-url"></mat-icon>
                    </a>
                </div>
                <div class="social-media-item" *ngFor="let socialMedia of publicProfile.redesSociales">
                    <a class="social-media-link" (click)="onSocialMediaClick(socialMedia)">
                        <mat-icon fontSet="phr-iconset" [ngClass]="getSocialMediaIcon(socialMedia)"></mat-icon>
                    </a>
                </div>
            </mat-card-subtitle>


            <div class="label-container" >
                <mat-icon fontSet="phr-iconset" [ngClass]="getFeatureConceptIconClassName()"></mat-icon>
                <span>{{getFeaturesConceptsText() | i18nText:locale.language }}</span>
            </div>
        </mat-card-header>
        <mat-card-actions>
            <button mat-button mat-flat-button class="btn-pay secondary" *ngIf="publicProfile.receptorPagoElectronico == 'S'" (click)="gotoPayment()">
                {{ 'publicProfiles.doctorHeader.buttonPay' | translate:locale.language }}
            </button>
            <button mat-button mat-flat-button class="btn-appointment primary" *ngIf="publicProfile.citaEnLineaHabilitada == 'S'" (click)="onAppointmentBtnClick()">
                {{ 'publicProfiles.doctorHeader.buttonAppointment' | translate:locale.language }}
            </button>
        </mat-card-actions>
    </mat-card>

    <mat-card class="skeleton-card" *ngIf="!showCard">
        <mat-card-content class="skeleton-card-padding">
            <div class="doc-img">
                <ngx-skeleton-loader [theme]="{ 'width': '136px', 'height': '136px', 'background-color': 'rgba(83, 86, 90, 0.14)', 'border-radius': '50%'}"></ngx-skeleton-loader>
            </div>
            <div class="doc-data">
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '35%', 'height': '24px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '4px', 'margin-bottom': '23px'}"></ngx-skeleton-loader>
                </div>
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '20%', 'height': '17px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
                </div>
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '26%', 'height': '17px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
                </div>                        
            </div>
            <div class="btn-container">
                <ngx-skeleton-loader [theme]="{ 'width': '177px', 'height': '49px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '30px'}"></ngx-skeleton-loader>
            </div>
        </mat-card-content>
    </mat-card>
</div>